const PITCH_CLASSES = ['C', 'C♯', 'D', 'D♯', 'E', 'F', 'F♯', 'G', 'G♯', 'A', 'A♯', 'B'];

export function formatDuration(ms: number | null): string | null {
  if (ms === null || Number.isNaN(ms)) {
    return null;
  }
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function formatMusicalKey(key: number | null, mode: number | null): string | null {
  if (key === null || key < 0 || key > 11) {
    return null;
  }
  const note = PITCH_CLASSES[key];
  if (!note) {
    return null;
  }
  if (mode === null) {
    return note;
  }
  return `${note} ${mode === 1 ? 'major' : 'minor'}`;
}
